import type { SVGProps } from 'react';
export const GridSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M3 3.68c0-.38.3-.68.68-.68h5.06c.37 0 .67.3.67.68v5.06c0 .37-.3.67-.67.67H3.68A.7.7 0 0 1 3 8.74zm1.35.67v3.7h3.7v-3.7zm6.24-.67c0-.38.3-.68.67-.68h5.06c.38 0 .68.3.68.68v5.06c0 .37-.3.67-.68.67h-5.06a.7.7 0 0 1-.67-.67zm1.35.67v3.7h3.7v-3.7zM3 11.26c0-.37.3-.67.68-.67h5.06c.37 0 .67.3.67.67v5.06c0 .38-.3.68-.67.68H3.68a.7.7 0 0 1-.68-.68zm1.35.68v3.7h3.7v-3.7zm6.24-.68c0-.37.3-.67.67-.67h5.06c.38 0 .68.3.68.67v5.06c0 .38-.3.68-.68.68h-5.06a.7.7 0 0 1-.67-.68zm1.35.68v3.7h3.7v-3.7z"
      clipRule="evenodd"
    />
  </svg>
);
